import { Injectable } from '@angular/core';

@Injectable()
export class LabelService {

  constructor() { }

  // returns an array of all labels (specified by key) found on the objects to filter
  getAllLabels(key: string, toFilter: any[]) {
    let labelObjects: any[] = [];

    for (let i = 0; i < toFilter.length; i++) {
      if (toFilter[i][key] != '') {
        let labelExists: boolean = false;

        for (let j = 0; j < labelObjects.length; j++) {
          if (toFilter[i][key] == labelObjects[j].label) {
            labelExists = true;
            break;
          }
        }

        if (!labelExists) {
          labelObjects.push({
            label: toFilter[i][key],
            checked: false
          });
        }
      }
    }
    return labelObjects.sort();
  }

  // returns an array of all objects to filter with enabled labels
  getObjectsWithLabels(key: string, labels: any[], toFilter: any[], allLabels: boolean) {
    let filteredObjects: any[] = [];

    for (let i = 0; i < toFilter.length; i++) {
      if (allLabels) {
        filteredObjects.push(toFilter[i]);
      } else {
        for (let j = 0; j < labels.length; j++) {
          if (toFilter[i][key] == labels[j].label && labels[j].checked) {
            filteredObjects.push(toFilter[i]);
          }
        }
      }
    }
    return filteredObjects;
  }

/*Note: This function says it checks all labels, in reality it unchecks them all
  It isn't used anywhere, so nbd, but I'm commenting it out */
  
  // checkAllLabels(labels: any[]) {
  //   for (let i = 0; i < labels.length; i++) {
  //     labels[i].checked = false;
  //   }
  //   return true;
  // }

  // yes these need to be separate
  checkIfAllLabelsAreChecked(labels: any[]) {
    for (let i = 0; i < labels.length; i++) {
      if (!labels[i].checked) {
        return false;
      }
    }

    return true;
  }

  checkIfAllLabelsAreUnChecked(labels: any[]) {
    for (let i = 0; i < labels.length; i++) {
      if (labels[i].checked) {
        return false;
      }
    }

    return true;
  }

  conditionallyEnableAllLabels(labels: any[]) {
    let allUnchecked = true;
    for (let i = 0; i < labels.length; i++) {
      if (labels[i].checked) {
        allUnchecked = false;
        break;
      }
    }
    if (allUnchecked) {
      return true;
    }
    return false;
  }

  toggleLabel(label: any) {
    return !label.checked;
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/helpers/label.service.ts